import { FormattedMessage } from 'react-intl';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export type InternalErrorStateProps = {
    reloadTriggerFunction?: () => void;
    className?: string;
    fullWidth?: boolean;
};

const InternalErrorState = ({ reloadTriggerFunction, className, fullWidth }: InternalErrorStateProps) => (
    <ErrorState
        headline={<FormattedMessage id="intl-msg:common.error.emptyState.headline" />}
        message={<FormattedMessage id="intl-msg:common.error.emptyState.message" />}
        buttons={[
            {
                text: <FormattedMessage id="intl-msg:common.error.emptyState.button" />,
                onClick: reloadTriggerFunction,
            },
        ]}
        innerClassName={className}
        fullWidth={fullWidth}
    />
);

export default InternalErrorState;
